// extracted by mini-css-extract-plugin
export default {"icon":"SkiLiftDistanceFeature-module__icon__-LoC0"};